import { render } from "./IconsView.vue?vue&type=template&id=66a252ee"
import script from "./IconsView.vue?vue&type=script&lang=js"
export * from "./IconsView.vue?vue&type=script&lang=js"

import "./IconsView.vue?vue&type=style&index=0&id=66a252ee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__